/**
 * Created by Jew on 18-Aug-2017
 */
import {
   ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef,
   ElementRef, HostListener, OnDestroy, OnInit, Renderer2, ViewChild, ViewContainerRef
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Meta, DomSanitizer, SafeResourceUrl, SafeHtml } from '@angular/platform-browser';
import { IdexService, Error } from 'app/idex.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MomentPipe } from 'app/shared/moment.pipe';
import { Mimetype } from 'app/shared/mimetype';
import { TranslateService } from '@ngx-translate/core';
import { DocTypeComponent } from '../../shared/doctype.component';
import { Toast } from '../../shared/toast/toast';
import { SharingComponent } from '../sharing/sharing.component';
import { Path } from '../../shared/path';
import { AppComponent } from '../../app.component';
import { UploadFilesComponent } from '../upload-files/upload-files.component';
import { ShareListComponent } from './sharelist/sharelist.component';
import { Subscription } from 'rxjs';
import { ShareDownloadZipComponent } from './share-download-zip/share-download-zip.component';
import { ShareDownloadFolderComponent } from './share-download-folder/share-download-folder.component';
import * as moment from 'moment';
import { AnnotationControllerService } from '../annotation-controller/annotation-controller.service';
import { DocumentData } from '../annotation-controller/document-data.type';
import { zDoxItem } from '../../shared/types';

declare const $: any;
declare const facebook: string; // Value declared in index.html
declare const isPdfTron: boolean; // Value declared in index.html

@Component({
   selector: 'app-view-share-public',
   templateUrl: './view-share-public.component.html',
   styleUrls: ['../viewer/viewer.component.css']
})
export class ViewSharePublicComponent implements OnInit, OnDestroy {
   private readonly SCOPE = 'https://www.googleapis.com/auth/drive.file';
   fb_app_id = facebook;
   isPdfTron = isPdfTron;
   doc: zDoxItem;
   documentData: DocumentData;

   form: any;
   selectedValue: any;
   share_id: any;
   comment: any;
   types: any[];
   settype = false;
   canNotPreview: boolean;
   text: string;
   mail: any;
   imageUrl: string;
   svg: SafeHtml;
   pdfUrl: SafeResourceUrl;
   videoUrl: string;
   audioUrl: string;
   post = 'ส่ง';
   lastModified: any;
   loaded = false;
   error: Error;
   downloads = false;
   dataShare: any;
   user: any;
   action_status = true;
   saveText = 'Save';
   item: any;
   path: any;
   pathTemp: any;
   isBusiness: boolean;
   showSideInfo = false;
   show: boolean;
   password: string;
   verify = true;
   readonly size = 5242880;

   notesPanelVisibilitySubscription: Subscription;
   private componentRef1: ComponentRef<{}>;
   private componentRef2: ComponentRef<{}>;

   @ViewChild('info') info: ElementRef;
   @ViewChild('selectType') selectType: any;
   @ViewChild('form1', { read: ViewContainerRef }) form1: ViewContainerRef;
   @ViewChild('form2', { read: ViewContainerRef }) form2: ViewContainerRef;
   private spacer = 20 + 38; // docList padding 20px + .content-container padding-bottom 38px

   canPrint: boolean;
   cancel = false;

   shareType: 'Public' | 'Anyone' | 'Private';

   // List document of folder

   private subscriber: Subscription;
   @ViewChild(ShareListComponent) docList: ShareListComponent;

   content: any;
   object_file: any;
   selectedItems: any[] = [];

   private page = 1;
   private pageSize = 50;
   private progress_dlg: MatDialogRef<UploadFilesComponent>;
   sharer: any;
   typeIsFolder = false;
   isFolder = false;
   public: boolean;
   isShowBackButton = false;
   permissionLevel = 0;
   isDownload = false;
   public canDrag = false;
   supportFolderUpload: boolean;
   paths: any[];
   shareDocId: string;
   itemId: string;

   constructor(
      private route: ActivatedRoute, private router: Router,
      public service: IdexService,
      private sanitizer: DomSanitizer, public dialog: MatDialog,
      private resolver: ComponentFactoryResolver,
      private changeDetector: ChangeDetectorRef,
      private translate: TranslateService, private toast: Toast,
      private meta: Meta, private app: AppComponent,
      private renderer: Renderer2,
      private annoService: AnnotationControllerService,) {
      this.translate.get('send').subscribe(s => {
         this.post = s;
      });
      this.translate.get('save').subscribe(s => {
         this.saveText = s;
      });
   }

   ngOnInit() {
      this.subscriber = this.route.url.subscribe(url => {
         this.path = decodeURIComponent(url.join('/'));

         this.service.logoUrl = sessionStorage.getItem('logoUrl');
         sessionStorage.removeItem('logoUrl');

         if (!this.service.shareDocId) {
            this.service.shareId = sessionStorage.getItem('shareId');
            this.service.shareDocId = sessionStorage.getItem('shareDocId');
            this.service.isDownload = sessionStorage.getItem('isDownload') === 'true';
            this.service.permissionLevel = parseInt(sessionStorage.getItem('permissionLevel'), 10);

            sessionStorage.removeItem('shareId');
            sessionStorage.removeItem('shareDocId');
            sessionStorage.removeItem('isDownload');
            sessionStorage.removeItem('permissionLevel');
         }

         if (sessionStorage.getItem('itemId')) {
            this.itemId = sessionStorage.getItem('itemId');
         }

         sessionStorage.setItem('shared', 'true');
         this.onLoadDoc();
      });

      this.notesPanelVisibilitySubscription = this.annoService.getNotesPanelVisibilityStatus().subscribe((isNotesPanelOpen) => {
         // If NotesPanel is open while side panel is already open, hide side panel
         if (isNotesPanelOpen && this.info?.nativeElement.className.indexOf('slide-right') === -1) {
            this.closeSidePanel();
         }
      });
   }

   ngOnDestroy() {
      this.notesPanelVisibilitySubscription?.unsubscribe();
   }

   onLoadDoc() {
      this.route.params.forEach((params: Params) => {
         this.share_id = params['shareId'];
         this.checkDevice('idex://share-public?key=' + this.share_id, this.share_id);
      });
   }

   @HostListener('window:beforeunload', ['$event'])
   unload($event: any) {
      sessionStorage.setItem('shareId', this.service.shareId);
      sessionStorage.setItem('shareDocId', this.service.shareDocId);
      sessionStorage.setItem('isDownload', this.service.isDownload.toString());
      sessionStorage.setItem('permissionLevel', this.service.permissionLevel.toString());
      sessionStorage.removeItem('verify');
      sessionStorage.setItem('logoUrl', this.service.logoUrl);
   }

   navigate(path: string) {
      sessionStorage.setItem('verify', this.verify.toString());
      if (path) {
         const url = Path.combine('/share-public', this.share_id, path);
         this.router.navigate([url]);
      } else {
         this.router.navigate(['/share-public', this.share_id]);
      }
   }

   getSharePublic() {
      this.service.sharePublic(this.share_id)
         .subscribe(data => {
            this.doc = data.item;
            this.doc.watermark = data.watermark
            this.shareType = data.type;

            if (this.shareType !== 'Public' && !this.user) {
               this.app.user = undefined;
               this.service.setUser();

               const url = window.location.pathname.replace('/idex', '');
               const shareId = url.replace('/share/', '').split('/')[0];
               const share_url = Path.combine('/login', encodeURIComponent('share/'), encodeURIComponent(shareId));
               this.router.navigate([share_url]);
            }

            this.permissionLevel = data.permissionLevel;
            this.isDownload = data.download;

            this.dataShare = data;
            sessionStorage.setItem('logoUrl', data.logoUrl);
            this.downloads = data.download;
            sessionStorage.setItem('dl', this.downloads.toString());
            sessionStorage.setItem('user-sharer', data.sharer);
            this.settype = !!this.doc.properties;
            this.show = Mimetype.canEdit(this.doc);
            this.canPrint = Mimetype.canPrint(this.doc);
            if (sessionStorage.getItem('verify')
               && sessionStorage.getItem('verify') === 'true') {
               this.verify = true;
            } else {
               this.verify = data.password ? false : true;
            }

            if (data.access !== 'Comment') {
               this.comment = data.comments;
            } else {
               this.getShareComment();
            }

            if (data.item.isFolder) {
               this.isFolder = true;
               this.canNotPreview = false;
               this.public = data.type === 'Public';

               this.pathTemp = this.doc.name + '/' + this.path;
               this.createBreadcrumb();

               localStorage.setItem('shareId', this.doc.id);
               sessionStorage.setItem('shareId', this.doc.id);
               if (this.verify) {
                  this.showDocument();
               }
            } else {
               if (this.verify) {
                  this.initDocument();
               }
            }

            if (!this.settype && data.type !== 'Public') {
               this.service.getShareTypes().subscribe(dataType => {
                  this.types = dataType;
                  this.settype = false;
               });
            } else {
               setTimeout(() => {
                  if (this.doc.properties) {
                     this.componentRef1 = DocTypeComponent.create(this.resolver, this.componentRef1,
                        this.form1, this.doc.properties);
                  }
                  this.updateContainerHeight();
               }, 200);
            }

            if (data.type === 'Private') {
               if (localStorage.getItem('url')) {
                  this.isShowBackButton = true;
               }
               for (const permission of this.dataShare.permissions) {
                  if (permission.id === this.user.email) {
                     this.dataShare.access = permission.access;
                     this.dataShare.allowShare = permission.allowShare;
                  }
               }
            } else {
               this.isShowBackButton = false;
            }

            this.updateMeta();

         }, error => {
            this.error = error;
         });
   }

   updateMeta() {
      this.meta.addTag({ property: 'og:url', content: window.location.toString() });
      this.meta.addTag({ property: 'og:type', content: 'website' });
      this.meta.updateTag({ property: 'og:title', content: this.doc.name });
      this.meta.addTag({ property: 'og:site_name', content: 'zDOX' });
      this.meta.addTag({
         property: 'og:image',
         content: 'https://www.getinvoice.net/wp-content/uploads/2018/06/webpage_idex.png'
      });
      this.meta.updateTag({ property: 'og:description', content: this.doc.description ? this.doc.description : '' });
      this.meta.addTag({ property: 'fb:app_id', content: this.fb_app_id });
      this.meta.addTag({ name: 'twitter:card', content: 'summary' });
      this.meta.addTag({ name: 'twitter:title', content: 'Shared From zDOX' });
      this.meta.addTag({ name: 'twitter:description', content: this.doc.description ? this.doc.description : '' });
      this.meta.addTag({
         name: 'twitter:image',
         content: 'https://www.getinvoice.net/wp-content/uploads/2018/06/webpage_idex.png'
      });
   }

   private createBreadcrumb(): void {
      const files = this.doc.name;
      if (this.path.length === 0) {
         this.paths = [{ name: files }];
         return;
      }

      const paths = [];
      paths.push({ name: files, path: '/' });

      let fullPath = '';
      const array = this.path.match(/[^/]+/g);
      for (let i = 0; i < array.length; i++) {
         if (i === array.length - 1) {
            fullPath = null;
         } else {
            if (fullPath.length > 0) {
               fullPath += '/';
            }
            fullPath += array[i];
         }
         paths.push({ name: array[i], path: fullPath });
      }
      this.paths = paths;
   }

   getIcon(item: any): string {
      return Mimetype.getIcon(item);
   }

   getShareComment() {
      this.service.shareComment(this.share_id)
         .subscribe(data => {
            this.comment = data.items;
         });
   }

   initDocument(): void {
      const mimeType = this.doc.mimeType;
      if (mimeType === 'application/pdf'
         || (['application/vnd.oasis.opendocument.text',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/msword',
            'application/vnd.ms-excel',
            'application/vnd.ms-powerpoint',
            'image/tiff',
         ].includes(mimeType) && this.doc.size <= this.size)) {
         const file = encodeURIComponent(this.service.url + '/share-public/' + this.share_id +
            '/content?' + Date.now());
         this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets/pdfjs/web/viewer.html?file=' + file);
         // LOAD DOCUMENT HERE!
         const docUrl = this.service.url + '/share-public/' + this.share_id + '/content?id=' + this.doc.id + '&isPdfTron=' + isPdfTron + '&' + Date.now();
         this.extracted(docUrl);

         // Office files stored in zDOX are converted to PDF, but the file name/extension may not change to .pdf
         this.documentData.fileFormat = "pdf";
      } else if (mimeType === 'image/jpeg' || mimeType === 'image/png') {
         this.imageUrl = this.service.url + '/share-public/' + this.share_id + '/content?' + Date.now();
         this.extracted(this.imageUrl);
      } else if (mimeType === 'image/svg+xml') {
         const svgUrl = '/share-public/' + this.share_id + '/content';
         this.extracted(svgUrl);
         this.service.get(svgUrl, { responseType: 'text' }).subscribe(data => {
            this.svg = this.sanitizer.bypassSecurityTrustHtml(data);
            this.loaded = true;
         });
      } else if (mimeType.indexOf('video/') === 0 && mimeType !== 'video/mpeg' && mimeType !== 'video/avi'
         && mimeType !== 'video/msvideo' && mimeType !== 'video/x-msvideo') {
         this.videoUrl = this.service.url + '/share-public/' + this.share_id + '/content';
      } else if (mimeType.indexOf('audio/') === 0) {
         this.audioUrl = this.service.url + '/share-public/' + this.share_id + '/content';
      } else if (mimeType.indexOf('text/') === 0 || mimeType === 'application/xml') {
         const url = '/share-public/' + this.share_id + '/content';
         this.service.get(url, { responseType: 'text' }).subscribe(data => {
            this.text = data;
            this.loaded = true;
         });
      } else if (mimeType === 'message/rfc822') {
         const url = '/share-public/' + this.share_id + '/content';
         this.service.get(url).subscribe((data: any) => {
            data.from = this.formatAddress(data.from);
            data.to = this.formatAddress(data.to);
            if (data.cc) {
               data.cc = this.formatAddress(data.cc);
            }
            if (data.html) {
               data.html = this.sanitizer.bypassSecurityTrustResourceUrl('data:text/html,' + data.html);
            }
            this.mail = data;
            this.loaded = true;
         });
      } else {
         this.canNotPreview = true;
         this.loaded = true;
      }
      const fmt = new MomentPipe();
      this.lastModified = { when: fmt.transform(this.doc.modified) };
   }

   /**
    * Extract properties from 'doc' to 'documentData'
    *
    * @param url
    * URL of the document to load and display in PDFTron
    */
   private extracted(url: string): void {
      this.documentData = {
         url: url + '&includeWatermark=false',
         fileName: encodeURIComponent(this.doc.name),
         type: this.doc.type,
         mimeType: this.doc.mimeType,
         docId: this.doc.id,
         path: this.doc.path,
         statusStartFlow: this.doc.startFlow,
         statusDocument: this.doc.statusDocument,
         isPermissions: this.doc.permissions,
         allowDownloadAndPrint: this.downloads,
         watermark: this.doc.watermark,
         actionType: "dms",
      };
      this.loaded = true; // Don't know what this is
      this.renderer.addClass(this.info.nativeElement, 'slide-right'); // Don't know what this is
   }

   private formatAddress(array: any[]): string {
      let s = '';
      array.forEach(addr => {
         if (s.length > 0) {
            s += ', ';
         }
         if (addr.name) {
            s += '<b>' + addr.name + '</b> ';
         }
         s += '&lt;' + addr.address + '&gt;';
      });
      return s;
   }

   frameLoaded(iframe: any) {
      const that = this;
      const document = iframe.contentWindow.document;
      document.addEventListener('pagesinit', function () {
         that.loaded = true;
         that.cancel = false;
         that.changeDetector.detectChanges();
      });

      setTimeout(() => {
         if (!this.loaded) {
            this.loaded = true;
            this.cancel = true;
         }
      }, 20000);
   }

   viewAttatchment(a: any) {
      const url = this.service.url + '/share-public/attachment?id=' + this.doc.id + '&aid=' + a.id;
      window.open(url, a.id || this.doc.id);
   }

   download() {
      if (this.doc.isFolder) {
         if (this.path === '') {
            this.service.get('/share-public/' + this.share_id + '/download')
               .subscribe(data => {
                  this.dialog.open(ShareDownloadFolderComponent, {
                     disableClose: true,
                     data: {
                        id: data.nodeRef,
                        name: this.doc.name,
                        service: this.service
                     }
                  });
               });
         } else {
            const arrDocName = this.path.split('/');
            const docName = arrDocName[arrDocName.length - 1];
            this.dialog.open(ShareDownloadFolderComponent, {
               disableClose: true,
               data: {
                  id: this.itemId,
                  name: docName,
                  service: this.service
               }
            });
         }
      } else {
         location.href = this.service.url + '/share-public/' + this.share_id + '/download';
      }
   }

   linkify(s: string): string {
      if (!s) {
         return s;
      }
      const urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
      // www. sans http:// or https://
      const pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      // Email addresses *** here I've changed the expression ***
      const emailAddressPattern = /(([a-zA-Z0-9_\-\.]+)@[a-zA-Z_]+?(?:\.[a-zA-Z]{2,6}))+/gim;
      return s.replace(urlPattern, '<a target="_blank" href="$&">$&</a>')
         .replace(pseudoUrlPattern, '$1<a target="_blank" href="http://$2">$2</a>')
         .replace(emailAddressPattern, '<a target="_blank" href="mailto:$1">$1</a>');
   }

   transform(value) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
   }

   private updateContainerHeight() {
      setTimeout(() => {
         const height = $('.info-body:visible').outerHeight(true) + $('.info-title').outerHeight(true);
         $('.list-container').css('min-height', height + 'px');
         this.adjustInfoPosition();
      }, 100);
   }

   private adjustInfoPosition() {
      const info = $('.info-body:visible');
      if (info.length === 0) {
         return;
      }

      const title = $('.info-title');
      const infoTop = title.position().top + title.outerHeight(true);
      const top = infoTop + 'px';
      if (window.scrollY > 0) {
         // TODO: detect scroll direction and use to calc position instead of window.scrollY
         const height = info.outerHeight(true);
         if (window.innerHeight - infoTop - height < 0) {
            const x = window.innerHeight - this.spacer;
            let y = infoTop - window.scrollY;
            if (y + height < x) {
               y = x - height;
            }
            info.css({ top: y + 'px' });
         } else {
            info.css({ top: top });
         }
      } else {
         info.css({ top: top });
      }
   }

   loadForm(name: string) {
      this.form = undefined;
      this.service.getShareType(name).subscribe(data => {
         this.form = data;
         this.componentRef2 = DocTypeComponent.create(this.resolver, this.componentRef2, this.form2, data);
         this.updateContainerHeight();
      });
   }

   private getProperties(form: any[]) {
      const error = function (e, msg) {
         e.focus();
         return null;
      };
      const properties = {};
      for (const element of form) {
         const f = element;
         const e = $('#' + f.name.replace(':', '_'));
         const value = e.val();
         if (f.mandatory && !value) {
            return error(e, f.label + ' is required');
         }
         if (f.constraints && value) {
            if (f.constraints.minLength && value.length < f.constraints.minLength) {
               return error(e, 'Minimum length of ' + f.label + ' is ' + f.constraints.minLength + ' characters');
            }
            if (f.constraints.maxLength && value.length > f.constraints.maxLength) {
               return error(e, 'Maximum length of ' + f.label + ' is ' + f.constraints.maxLength + ' characters');
            }
            if (f.constraints.minValue !== undefined && value < f.constraints.minValue) {
               return error(e, 'Minimum value of ' + f.label + ' is ' + f.constraints.minValue);
            }
            if (f.constraints.maxValue !== undefined && value > f.constraints.maxValue) {
               return error(e, 'Maximum value of ' + f.label + ' is ' + f.constraints.maxValue);
            }
            if (f.constraints.expression && !new RegExp(f.constraints.expression).test(value)) {
               return error(e, 'Value of ' + f.label + ' did not match the pattern');
            }
         }
         properties[f.name] = value;
      }
      return properties;
   }

   getExpired(exp: any) {
      return moment(exp).format('dddd DD MMMM YYYY hh:mm:ss');
   }

   back() {
      this.router.navigate(['/']);
   }

   verifyPassword(input: any) {
      if (input.value.length === 0) {
         input.focus();
         return;
      }
      this.service.post('share-public/' + this.share_id + '/verify', { password: input.value })
         .subscribe(res => {
            this.setVerify();
         });
   }

   setVerify() {
      this.verify = true;
      setTimeout(() => {
         if (this.dataShare.item.isFolder) {
            this.showDocument();
         } else {
            this.initDocument();
         }

         if (this.doc.properties) {
            this.componentRef1 = DocTypeComponent.create(this.resolver, this.componentRef1, this.form1, this.doc.properties);
         }
         this.updateContainerHeight();
      }, 200);
   }

   share() {
      this.dialog.open(SharingComponent, {
         disableClose: true,
         data: {
            id: this.doc.id,
            name: this.doc.name,
            service: this.service,
            toast: this.toast,
            role: this.service.role,
            item: this.doc
         }
      });
   }

   back_left() {
      if (this.service.user != null) {
         this.router.navigate([localStorage.getItem('url')]);
         localStorage.removeItem('url');
      } else {
         this.router.navigate(['/login']);
      }
   }

   toggle(): void {
      if (!this.info) return;

      // If side panel is currently open
      if (this.info.nativeElement.className.indexOf('slide-right') === -1) {
         // Hide side panel
         this.closeSidePanel();
      } else {
         // Show side panel
         this.openSidePanel();
      }
   }
   closeSidePanel(): void {
      this.renderer.addClass(this.info.nativeElement, 'slide-right');
   }
   openSidePanel(): void {
      //| When DMS side panel is open,
      //| if PDFTron's NotesPanel is also open, close it.
      this.annoService.instance?.UI.closeElements(['notesPanel']);
      this.annoService.instance?.Core.documentViewer.getAnnotationManager().deselectAllAnnotations();

      this.renderer.removeClass(this.info.nativeElement, 'slide-right');
   }

   printFrame() {
      const iframe = window.frames['printf'];
      iframe.focus();
      iframe.print();
   }

   checkDevice(path, shareId) {
      if (this.docList) {
         this.docList.items = undefined;
      }
      this.getSharePublic();
   }

   showDocument() {
      this.selectedItems = [];
      this.page = 1;
      this.service.listShareDocuments(this.pathTemp, this.page, this.pageSize, this.sharer,
         this.doc.id, this.shareType, this.isDownload, this.permissionLevel)
         .subscribe(
            data => {
               if (this.docList) {
                  this.docList.permissionLevel = this.permissionLevel;
                  this.docList.setItems(data.items, data.hasMore);
                  document.body.scrollTop = 0;
               }
               this.loaded = true;
            });
   }

   onLoadMore() {
      const sharedId = this.doc.id;
      this.service.listShareDocuments(this.pathTemp, this.page + 1, this.pageSize, this.sharer,
         sharedId, this.shareType, false, 0)
         .subscribe(
            data => {
               this.docList.addItems(data.items, data.hasMore);
               if (data.hasMore) { this.page++; }
            });
   }

   onClickItem(item: any) {
      localStorage.setItem('sharer', item.modifier.id);
      let path = location.pathname;
      const idex = '/idex';
      if (path.startsWith(idex)) {
         path = path.substring(idex.length);
      }

      if (item.shareId) {
         this.service.shareId = item.shareId;
         this.service.shareDocId = item.id;
         this.service.isDownload = item.isDownload;
         this.service.permissionLevel = item.permissionLevel;
      } else {
         sessionStorage.setItem('itemId', item.id);
      }

      sessionStorage.setItem('verify', this.verify.toString());
      localStorage.setItem('url', Path.combine(path));
      this.redirect(item);
   }

   redirect(item: any) {
      if (item.isFolder) {
         this.service.shareType = this.shareType;
         const url = Path.combine('/share-public', this.share_id, encodeURIComponent(this.path), encodeURIComponent(item.name));
         this.router.navigate([url]);
      } else {
         this.router.navigate(['/sharefile', item.id]);
      }
   }

   selectedDownload() {
      const listIds = [];
      let name = 'Archive';
      if (this.selectedItems) {
         if (this.selectedItems.length === 1) {
            name = this.selectedItems[0].name;
         }
         for (const itemSel of this.selectedItems) {
            listIds.push(itemSel.id);
         }
      }

      this.dialog.open(ShareDownloadZipComponent, {
         disableClose: true,
         data: {
            idList: listIds,
            name: name,
            service: this.service
         }
      });
   }
}
